import { render } from "./StoreCouponTable.vue?vue&type=template&id=27b82744&scoped=true"
import script from "./StoreCouponTable.vue?vue&type=script&lang=js"
export * from "./StoreCouponTable.vue?vue&type=script&lang=js"

import "./StoreCouponTable.vue?vue&type=style&index=0&id=27b82744&scoped=true&lang=css"

import exportComponent from "D:\\code\\tea-web\\tea-web\\tea-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27b82744"]])

export default __exports__